"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
// Datos cabecera y pie
const getHeaderFooterInfo = (store, context, currentPathname) => __awaiter(void 0, void 0, void 0, function* () {
    const modules = yield Promise.all([
        yield Promise.resolve().then(() => __importStar(require("@gcloud-npm/adabyron.misc.get-static-content"))),
        yield Promise.resolve().then(() => __importStar(require("@gcloud-npm/normalizers.components-header.sections"))),
        yield Promise.resolve().then(() => __importStar(require("@gcloud-npm/normalizers.components-header.breadcrumbs"))),
        yield Promise.resolve().then(() => __importStar(require("@/bit/reducers/reducers.header-reducer"))),
        yield Promise.resolve().then(() => __importStar(require("@gcloud-npm/adabyron.custo.get-seo"))),
        yield Promise.resolve().then(() => __importStar(require("@gcloud-npm/adabyron.custo.get-by-name"))),
    ]);
    const getHeaderSections = modules[1].default;
    const getBreadcrumbs = modules[2].default;
    const headerActions = modules[3].actions;
    const getByName = modules[5].default;
    // HEADER
    let headerProps, breadcrumbsProps;
    if (currentPathname) {
        let [breadcrumbsInfoJson, headerInfoJson] = yield Promise.all([
            getByName({
                name: "HEADER-INFO",
                kind: "activity",
                context,
                build: true,
            }),
            // esto viene de la actividad del burguer
            getByName({
                name: "HEADER-BURGUER-MENU-1",
                kind: "creativity",
                context,
                build: true,
            }),
        ]);
        // HEADER USUAL PROPS
        breadcrumbsProps = getBreadcrumbs(breadcrumbsInfoJson, currentPathname);
        // HEADER REDUX PROPS
        headerProps = getHeaderSections(headerInfoJson, breadcrumbsProps);
        store.dispatch(headerActions.setHeaderLocation(currentPathname));
        store.dispatch(headerActions.setupHeaderProps(headerProps));
    }
    // FOOTER USUAL PROPS
    const footerProps = yield getByName({
        name: "FOOTER-INFO",
        kind: "activity",
        context,
        build: true,
    });
    return { headerProps, breadcrumbsProps, footerProps };
});
exports.default = getHeaderFooterInfo;
//# sourceMappingURL=index.js.map